import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions/transport';
import logoBus from '../assets/bus.png';
import ligne72 from '../assets/72.png';

class TransportInfo extends React.Component {
    componentDidMount() {
        this.props.fetchNextBus();
        this.props.fetchNextTrain();

        this.busInterval = setInterval(
            function() {
                this.props.fetchNextBus();
            }.bind(this),
            30 * 1000
        );

        this.trainInteval = setInterval(
            function() {
                this.props.fetchNextTrain();
            }.bind(this),
            50 * 1000
        );
    }

    componentWillUnmount() {
        clearInterval(this.busInterval);
        clearInterval(this.trainInteval);
    }

    render() {
        return (
            <div className="transport">
                <div className="transport__sncf">
                    <div className="sncf-logo">
                        <svg
                            id="train"
                            viewBox="0 0 48 48"
                            width="26px"
                            height="26px"
                        >
                            <g id="Train">
                                <path
                                    stroke="#FFFFFF"
                                    fill="#FFFFFF"
                                    id="path4"
                                    d="M43.75 32.1c-.1-.1-.1-.3-.2-.4.7-.6 1.1-1.7 1.1-2.7-.1-10-8.8-19-19.4-19H6.65c-.6 0-1 .4-1 1s.4 1 1 1h18.6c4.7 0 9 1.9 12.1 5h-5.5c-.3 0-.6.1-.8.3s-.3.5-.3.8.1.6.3.8l5.8 5.7c.4.5 1.1.7 1.7.8h3.6c.3 1.3.5 2.6.5 3.9 0 .5-.2.9-.5 1.2s-.8.5-1.4.5H6.65c-.6 0-1 .4-1 1s.4 1 1 1h34.7c.3 0 .6.2.9.5s.4.7.4 1.1v.1c0 .4-.2.7-.4 1-.3.1-.6.3-.9.3H6.65c-.6 0-1 .4-1 1s.4 1 1 1h34.7c.9 0 1.8-.4 2.4-1s1-1.5 1-2.4v-.1c-.1-.9-.5-1.7-1-2.4zm-5.2-7.7c-.4 0-.7-.2-1-.5l-5.8-5.7v-.1s0-.1.2-.1h6.5c1.6 2 2.9 4 3.6 6.4h-3.5zm-10.3.9c.4 0 .7-.2 1-.4.2-.2.5-.5.5-.9 0-.2-.1-.5-.3-.7l-6.1-5.9c-.3-.3-.7-.4-1-.4H5.95c-.3 0-.5.2-.5.5s.2.5.5.5h16.4c.1 0 .3.1.3.1l6 5.8-.2.2c-.1.1-.2.1-.3.1H5.75c-.3 0-.5.2-.5.5s.2.5.5.5l22.5.1z"
                                />
                            </g>
                        </svg>
                    </div>
                    <div className="transport__delai">
                        {this.props.nextTrain !== undefined
                            ? this.props.nextTrain.map((train, index) => (
                                  <span
                                      key={index}
                                      className="transport__next-passage transport__next-passage__sncf"
                                  >
                                      {' '}
                                      {train.destination} :{' '}
                                      {train.timeToWait === 0
                                          ? 'Proche'
                                          : train.timeToWait}
                                  </span>
                              ))
                            : 'NOK'}
                    </div>
                </div>
                <div className="transport__tcl">
                    <div className="tcl-logos">
                        <img
                            className="logo-tcl logo-bus"
                            src={logoBus}
                            alt="ligne 72"
                        />
                        <img
                            className="logo-tcl logo-ligne"
                            src={ligne72}
                            alt="ligne 72"
                        />
                    </div>
                    <div className="transport__delai">
                        <span className="transport__next-passage transport__next-passage__tcl">
                            {this.props.nextBus !== undefined &&
                            this.props.nextBus.length > 0
                                ? this.props.nextBus[0].delaipassage
                                : ''}
                        </span>
                        <span className="transport__next-passage transport__next-passage__tcl">
                            {this.props.nextBus !== undefined &&
                            this.props.nextBus.length > 1
                                ? this.props.nextBus[1].delaipassage
                                : ''}
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        nextBus: state.transport.nextBus,
        nextTrain: state.transport.nextTrain,
    };
}

export default connect(mapStateToProps, actions)(TransportInfo);



// WEBPACK FOOTER //
// ./src/components/TransportInfo.js